function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "b78rjyq3la",
  d: "M12 6.111C12 5.5 12.5 5 13.11 5h1.112c.611 0 1.111.5 1.111 1.111s-.5 1.111-1.11 1.111H13.11v5.472c0 1.105-.772 2.105-1.862 2.278-1.516.238-2.805-1.061-2.55-2.584.134-.777.706-1.438 1.45-1.705.684-.239 1.328-.122 1.85.178V6.11z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -2) translate(0 2)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#201D1A",
  d: "M21.6 2.443H12L10.308.7C9.852.249 9.24 0 8.604 0H2.4C1.08 0 0 1.069 0 2.375v14.25C0 17.931 1.08 19 2.4 19h19.2c1.32 0 2.4-1.069 2.4-2.375V4.75c0-1.306-1.08-2.307-2.4-2.307z"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#b78rjyq3la"
}));

var SvgBeatFolder = function SvgBeatFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeatFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/beatFolder.4a659d58.svg";
export { ForwardRef as ReactComponent };